/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIModelDTO } from '../models/AIModelDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiModelService {

    /**
     * Get all
     * @returns AIModelDTO
     * @throws ApiError
     */
    public static aiModelControllerGetAll(): CancelablePromise<Array<AIModelDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai-models',
        });
    }

}
